import { ReactElement } from "react"

import AmendEbDeviceForm from "../../../../components/devices/lct/eb/amendEbDeviceForm"
import NewEbDeviceAmendmentProvider from "../../../../components/devices/lct/eb/providers/newEbDeviceAmendmentProvider"

/** Root webpage for amending an Electric Boiler device */
const AmendEbDevice = (): ReactElement => (
    <NewEbDeviceAmendmentProvider>
        <AmendEbDeviceForm />
    </NewEbDeviceAmendmentProvider>
)

export default AmendEbDevice
